(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc"] && !Shopify.designMode) return;
  try {
    
  class KsStickyAtc extends HTMLElement {
    constructor () {
      super()

      this.variantSelector = this.querySelector('select[name="id"]')
      this.mainVariantInput = document.querySelector('.product .product-form input[name="id"]')

      this.handleVisibility()
      this.handleVariantChange()
      this.handleMainVariantChange()
    }

    handleVisibility () {
      const top = document.querySelector('product-info product-form').getBoundingClientRect().bottom + window.scrollY

      window.addEventListener('scroll', () => {
        if (window.scrollY > top) {
          this.classList.add('show')
          document.body.style.paddingBottom = this.clientHeight + 'px'
        } else {
          this.classList.remove('show')
          document.body.style.paddingBottom = 0
        }
      })
    }

    handleVariantChange () {
      if (!this.variantSelector) return

      this.variantSelector.addEventListener('change', () => {
        const selectedOption = this.variantSelector.querySelector('option:checked')
        const variantImg = selectedOption.getAttribute('data-img')
        const variantComparePrice = selectedOption.getAttribute('data-compare-price')
        const variantPrice = selectedOption.getAttribute('data-price')

        this.querySelectorAll('img').forEach(elem => {
          elem.src = variantImg
        })
 
        this.querySelectorAll('.price').forEach(elem => {
          if (variantComparePrice.length) {
            elem.classList.add('price--on-sale')
            elem.querySelector('.price__sale .price-item--regular').textContent = variantComparePrice
            elem.querySelector('.price__sale .price-item--sale').textContent = variantPrice
          } else {
            elem.classList.remove('price--on-sale')
            elem.querySelector('.price__regular .price-item--regular').textContent = variantPrice
          }
        })

        this.querySelectorAll('button[name="add"]').forEach(btn => {
          if (selectedOption.disabled) {
            btn.disabled = true
            btn.querySelector('span').textContent = this.dataset.textSoldOut
          } else {
            btn.disabled = false
            btn.querySelector('.sold-out-message').classList.add('hidden')
            btn.querySelector('span').textContent = this.dataset.textAddToCart
          }
        })
      })
    }

    handleMainVariantChange () {
      this.mainVariantInput.addEventListener('change', (event) => {
        this.variantSelector.value = this.mainVariantInput.value
        this.variantSelector.dispatchEvent(new Event('change'))
      })
    }
  }
  customElements.define('ks-sticky-atc', KsStickyAtc)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-video"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Глобальний завантажувач Swiper (одноразово, без race conditions)
  function loadSwiperOnce () {
    if (window._ksSwiperLoader) return window._ksSwiperLoader

    window._ksSwiperLoader = new Promise((resolve, reject) => {
      const onReady = () => {
        if (window.Swiper) { resolve(); return }
      }

      // CSS
      if (!document.querySelector('#swiper-stylesheet')) {
        const stylesheet = document.createElement('link')
        stylesheet.href = 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css'
        stylesheet.rel = 'stylesheet'
        stylesheet.id = 'swiper-stylesheet'
        stylesheet.integrity = 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow='
        stylesheet.crossOrigin = 'anonymous'
        document.head.appendChild(stylesheet)
      }

      // JS
      if (!document.querySelector('#swiper-script')) {
        const script = document.createElement('script')
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js'
        script.id = 'swiper-script'
        script.integrity = 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0='
        script.crossOrigin = 'anonymous'
        script.onload = onReady
        script.onerror = () => reject(new Error('Failed to load Swiper'))
        document.head.appendChild(script)
      } else {
        // Якщо скрипт уже є — чекаємо поки зʼявиться window.Swiper
        if (window.Swiper) { resolve(); return }
        const maxWait = 2000
        const started = Date.now()
        const tick = () => {
          if (window.Swiper) { resolve(); return }
          if (Date.now() - started > maxWait) {
            reject(new Error('Swiper not available'))
            return
          }
          requestAnimationFrame(tick)
        }
        tick()
      }
    })

    return window._ksSwiperLoader
  }

  class KsShoppableVideos extends HTMLElement {
    constructor () {
      super()
      this._destroyed = false
      this._swiper = null
    }

    connectedCallback () {
      loadSwiperOnce()
        .then(() => {
          if (this._destroyed) return
          this.initSlider()
          this.bindVideoControls()
          this.setupAutoplayObserver()
        })
        .catch(() => {
          const root = this.querySelector('.swiper')
          if (root) root.classList.add('ks-fallback-visible')
        })
    }

    disconnectedCallback () {
      this._destroyed = true
      if (this._swiper && this._swiper.destroy) {
        this._swiper.destroy(true, true)
        this._swiper = null
      }
    }

    initSlider () {
      const root = this.querySelector('.swiper')
      if (!root) return

      const options = this.buildOptions({
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
        paginationEl: this.querySelector('.swiper-pagination'),
        scrollbarEl: this.querySelector('.swiper-scrollbar'),
      })

      try {
        this._swiper = new window.Swiper(root, options)

        this._swiper.on('slideChange', () => {
          root.classList.add('swiper-is-changing')
          this.onSlideChange()
        })
        this._swiper.on('slideChangeTransitionEnd', () => {
          root.classList.remove('swiper-is-changing')
        })
      } catch (e) {
        root.classList.add('ks-fallback-visible')
      }
    }

    buildOptions (els) {
      const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1
      return {
        rewind: true,
        speed: Number(this.dataset.sliderSpeed),
        breakpoints: {
          0:    { slidesPerView: Number(this.dataset.breakpointXs)  * partialSlidesMobile },
          576:  { slidesPerView: Number(this.dataset.breakpointSm)  },
          768:  { slidesPerView: Number(this.dataset.breakpointMd)  },
          992:  { slidesPerView: Number(this.dataset.breakpointLg)  },
          1200: { slidesPerView: Number(this.dataset.breakpointXl)  },
          1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
        },
        navigation: {
          enabled: this.dataset.sliderNav === 'true',
          nextEl: els.nextEl,
          prevEl: els.prevEl
        },
        pagination: {
          enabled: this.dataset.sliderPagination === 'true',
          type: this.dataset.sliderPaginationType,
          el: els.paginationEl,
          dynamicBullets: true,
          dynamicMainBullets: 2,
          renderFraction: (currentClass, totalClass) =>
            `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        },
        scrollbar: {
          enabled: this.dataset.sliderScrollbar === 'true',
          el: els.scrollbarEl,
          draggable: true
        },
        autoplay: this.dataset.sliderAutoplay !== '0'
          ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
          : undefined,
        watchSlidesProgress: true,
        mousewheel: { enabled: true, forceToAxis: true },
      }
    }

    bindVideoControls () {
      this.querySelectorAll('.ks-shoppable-videos-btn-play').forEach(btn => {
        btn.addEventListener('click', () => {
          const video = btn.closest('.ks-shoppable-videos-video-wrapper')?.querySelector('video')
          if (video) this.onVideoPlay(video)
        })
      })

      this.querySelectorAll('video').forEach(video => {
        video.addEventListener('click', () => this.onVideoPlay(video))
      })
    }

    setupAutoplayObserver () {
      const lazyVideosObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { if (entry.isIntersecting) entry.target.play() })
      }, { rootMargin: '0px 0px 300px 0px' })

      this.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
        lazyVideosObserver.observe(el)
      })
    }

    onSlideChange () {
      this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      })
    }

    onVideoPlay (video) {
      const card = video.closest('.ks-shoppable-videos-card')
      if (!card) return

      this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
        if (elem.dataset.index !== card.dataset.index) {
          elem.setAttribute('data-is-playing', 'false')
          elem.querySelector('video')?.pause()
        }
      })

      const isPlaying = card.dataset.isPlaying === 'true'
      card.setAttribute('data-is-playing', isPlaying ? 'false' : 'true')
      if (isPlaying) {
        video.pause()
      } else {
        video.muted = true
        video.play()
      }
    }
  }

  customElements.define('ks-shoppable-videos', KsShoppableVideos)
})();

  } catch(e) { console.error(e); }
})();
})();
